<template>
  <select-buttons :options="options" size="lg" />
</template>

<script>
/* eslint-disable global-require */
import SelectButtons from '@/components/base/SelectButtons';

export default {
  name: 'GenderSelectionImageButton',
  components: { SelectButtons },
  props: {
    genderEnum: Object,
  },
  computed: {
    options() {
      return [
        {
          img: require('@/assets/common/female.svg'),
          label: 'נקבה',
          action: () => this.$emit('input', this.genderEnum.FEMALE),
          value: this.genderEnum.FEMALE,
        },
        {
          img: require('@/assets/common/male.svg'),
          label: 'זכר',
          action: () => this.$emit('input', this.genderEnum.MALE),
          value: this.genderEnum.MALE,
        },
      ];
    },
  },
};
</script>
